<div *ngIf="checkViewMode('edit')" class="form-group">
  <label for="">
    {{ showTitle ? getTitle() : '' }}
    <span class="error-indication" *ngIf="isRequired()">{{getError()}}</span>
  </label>
  <textarea class="form-control m-textarea"
    [class.has-error]="attribute.hasError"
    (keypress)="onMaxlength($event, getOptionByKey(attribute,'maxlength'))"
    [maxlength]="getOptionByKey(attribute,'maxlength')"
    [(ngModel)]="attribute.value"
    [rows]="getOptionByKey(attribute,'rows')"
    [tabindex]="getOptionByKey(attribute,'tabIndex')"
    [disabled]="disabled ? true : false"
    [required]="getOptionByKey(attribute,'required')"
    [placeholder]="getOptionByKey(attribute,'placeholder')"
    (blur)="onBlur()">
  </textarea>
</div>

<p *ngIf="checkViewMode('view')"><span>{{getTitle()}}: </span></p>
<p *ngIf="checkViewMode('view')" [innerHTML]="getHtmlText()"></p>
